import { ChangeDetectionStrategy, Component } from '@angular/core';
import { NavController } from 'providers/nav-controller';
import { ITestUiToastsPage } from 'pages/test-ui-toasts/test-ui-toasts-interface';
import { ITestUiNutrientsPage } from 'pages/test-ui-nutrients/test-ui-nutrients-interface';
import { IPurchaseSuccessPage } from 'pages/purchase-success/purchase-success-interface';

// The Component Test Pages card's body on the Test UI Components page: buttons that open the other
// test pages.
@Component({
  selector: 'cs-test-navigation-card',
  host: { class: 'showcase-card-body' },
  template: `
    <cs-item-list>
      <cs-item>
        <cs-button item-right (click)="goToToastTests()" [label]="'Toast Component Tests' | untranslated"
          data-test="go-to-toast-tests" fit-width>
        </cs-button>
      </cs-item>
      <cs-item>
        <cs-button item-right (click)="goToNutrientTests()" [label]="'Nutrient List Tests' | untranslated"
          data-test="go-to-nutrient-tests" fit-width>
        </cs-button>
      </cs-item>
      <cs-item>
        <cs-button item-right (click)="openPurchaseSuccessPage()" [label]="'Purchase Success Page' | untranslated"
          data-test="open-purchase-success-page" fit-width>
        </cs-button>
      </cs-item>
    </cs-item-list>
  `,
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsTestNavigationCardComponent {
  constructor(private navCtrl: NavController) {}

  async goToToastTests() {
    await this.navCtrl.pushAsync(ITestUiToastsPage, {});
  }

  async goToNutrientTests() {
    await this.navCtrl.pushAsync(ITestUiNutrientsPage, {});
  }

  async openPurchaseSuccessPage(): Promise<void> {
    await this.navCtrl.pushAsync(IPurchaseSuccessPage, {
      androidInstallUrl: 'https://play.google.com/store/apps/details?id=app.mhphysique.fitness&referrer=purchaseClaimToken%3DTESTPREVIEW',
      iosInstallUrl: 'https://apps.apple.com/app/id6767633069'
    });
  }
}
